import { useAsyncExecutor } from "async-executor-hook";
import { useState } from "react";
import { useHistory } from "react-router-dom";

import LoadingSpinner from "../../images/icon_loading_green.gif";
import TalmaLogo from "../../images/talmaclick_logo_white.png";
import { authenticate } from "../../utils/authUtils";
import { BETA_FEATURES } from "../../utils/constants";
import Input from "../Input/Input";
import SessionExpiredModal from "../SessionExpiredModal/SessionExpiredModal";
import {
  LoginContainer,
  LoginInfo,
  MainButton,
  TalmaInfo,
} from "./LoginStyles";

function Login(props: any) {
  const [email, updateEmail] = props.emailState;
  const [password, updatePassword] = useState("");

  const [loginError, updateLoginError] = useState(false);

  const storageSessionExpired = sessionStorage.getItem("sessionExpired");
  const [hasSessionExpired, updateHasSessionExpired] = useState(
    storageSessionExpired === "true"
  );

  const toggleModal = () => {
    updateHasSessionExpired(!hasSessionExpired);
    sessionStorage.removeItem("sessionExpired");
  };

  const onChangeEmail = (e: any) => {
    if (loginError) updateLoginError(false);
    updateEmail(e.target.value);
  };

  const onChangePassword = (e: any) => {
    if (loginError) updateLoginError(false);
    updatePassword(e.target.value);
  };

  const onEnter = (e: any) => {
    if (e.keyCode !== 13) return;
    authenticateUser.execute({ email, password });
  };

  const authenticateUser = useAsyncExecutor(
    (params: any) => {
      return authenticate(params.email.trim(), params.password);
    },
    {
      onSuccess: (response: any) => {
        localStorage.setItem("accessToken", response.accessToken.jwtToken);
        window.location.href = "/";
      },
      onError: () => {
        updateLoginError(true);
      },
    }
  );

  const history = useHistory();
  return (
    <>
      {hasSessionExpired && (
        <SessionExpiredModal onClickRefresh={toggleModal} />
      )}
      {!hasSessionExpired && (
        <LoginContainer>
          <TalmaInfo>
            <img className="talmaLogo" src={TalmaLogo} alt="logo" />
          </TalmaInfo>
          <LoginInfo>
            <div className="loginTitle">Iniciar sesión</div>
            <div>
              <div className="emailInput">
                <p>Email</p>
                <Input
                  placeholder="johndoe@mail.com"
                  width="30.8rem"
                  type="email"
                  value={email}
                  onChange={onChangeEmail}
                  onKeyDown={onEnter}
                  hasError={authenticateUser.isError}
                />
              </div>
              <div className="passwordInput">
                <p>Contraseña</p>
                <Input
                  type="password"
                  width="30.8rem"
                  value={password}
                  onChange={onChangePassword}
                  onKeyDown={onEnter}
                  hasError={authenticateUser.isError}
                />
              </div>
              {BETA_FEATURES.PASSWORD_RECOVERY && (
                <p
                  className="forgotPassword"
                  onClick={() => {
                    history.push(`/guest/forgot-password`);
                  }}
                >
                  ¿Olvidaste tu contraseña?
                </p>
              )}
            </div>
            <MainButton
              onClick={() => {
                authenticateUser.execute({ email, password });
              }}
              disabled={authenticateUser.isLoading}
            >
              {authenticateUser.isLoading && (
                <img
                  src={LoadingSpinner}
                  width="50"
                  height="50"
                  alt="Processing request"
                />
              )}
              Iniciar sesión
            </MainButton>
            {authenticateUser.isError && (
              <div className="error-message">
                ¡Ups! Parece que hubo un error, inténtalo de nuevo.
              </div>
            )}
          </LoginInfo>
        </LoginContainer>
      )}
    </>
  );
}
export default Login;
